import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { NotYetPaidModal, UserSessionModal } from 'components/Modals'
import PasswordAuditModal from 'components/Modals/PasswordAuditModal'
import Header from './Header'
import Menu from './Menu'
import Title from './Title'
import PaymentRemainder from './PaymentRemainder'

import { content } from './styles'

const Dashboard = ({
  children,
  title,
  hasPaid,
  userStatus,
  hideModal = false,
  hideLateralMenu = false,
  subtitle = null,
  hideSessionModal = hideModal,
}) => (
  <div
    className={classNames('container', {
      'hide-lateral-menu': hideLateralMenu,
    })}
  >
    {!hideModal && <NotYetPaidModal />}
    {!hideSessionModal && <UserSessionModal />}
    <PasswordAuditModal />
    {!hideLateralMenu && <Menu initialExpanded={false} />}
    <main className="content">
      <Header />
      {title ? <Title subtitle={subtitle}>{title}</Title> : null}
      <PaymentRemainder />
      {children}
    </main>
    <style jsx>{content}</style>
  </div>
)

Dashboard.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  hideModal: PropTypes.bool,
  subtitle: PropTypes.any,
}

export default Dashboard
